import { DeviceWidth } from '@sbt-web/ui';

export const isMobileViewport = (): boolean =>
  window.matchMedia(`(max-width: ${DeviceWidth.mobile.max})`).matches;

export const isDesktopViewport = (): boolean =>
  window.matchMedia(`(min-width: ${DeviceWidth.desktop.min})`).matches;
